export const getDialog = (id: string) => {
  const dialog = document.getElementById(id) as HTMLDialogElement;

  if (!dialog) {
    console.warn(`Could not find dialog with id: ${id}`);
  }

  return dialog;
}

export const showDialog = (id: string) => {
  const dialog = getDialog(id);

  if (!dialog) {
    return;
  }

  dialog.showModal();
}

export const closeDialog = (id: string) => {
  const dialog = getDialog(id);

  if (!dialog) {
    return;
  }

  dialog.close();
}

export const useDialog = (id: string) => {
  return {
    exists: () => !!getDialog(id),
    open: () => showDialog(id),
    close: () => closeDialog(id),
  }
}

export default useDialog;